module.exports = __webpack_public_path__ + "img/wood.208bc477.png";